import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttributesComponent } from './attributes.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FuseSharedModule } from '@fuse/shared.module';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';




@NgModule({
  declarations: [
      AttributesComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatFormFieldModule,
        FuseSharedModule,

        MatCheckboxModule,
        MatChipsModule,
        MatIconModule,
        TranslateModule
    ],
  exports:[
    AttributesComponent
]
})

export class AttributesModule { }
